import axios from 'axios';

interface Response {
  name: string;
  value: string;
}

export const fetchThirdPartyKeys = (serviceName: string) =>
  axios.get<Response>(`/api/third_party_keys?service=${serviceName}`);
